let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2IKbl")).then(() => parcelRequire('24U8y'));